import { j as n, c as a } from "../../utils-BdNIfrGQ.js";
import { n as o } from "../../normalize-spacing-DY0KSpr_.js";
import { c as s } from "../../index-Di82Y7n3.js";
const i = s(
  "inline-flex items-center rounded-full border px-5 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "border border-gray-400 bg-background text-foreground",
        outlineLabel: "rounded-[8px] px-3 py-[2px] text-sm w-fit bg-primary-foreground border-2 border-primary text-primary font-semibold"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function d({ className: r, variant: e, ...t }) {
  return /* @__PURE__ */ n.jsx("div", { className: a(i({ variant: e }), r), ...t });
}
const u = ({ spacing: r, children: e, ...t }) => /* @__PURE__ */ n.jsx(
  d,
  {
    className: a(o(r), "inline-flex items-center leading-snug"),
    ...t,
    children: e
  }
);
u.displayName = "Badge";
export {
  u as default
};
